import { Component } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { GigyaService } from "../../services/gigya.service";
import { SpinnerComponent } from "../../shared/icons/spinner/spinner.component";
import { TranslatePipe } from "@ngx-translate/core";
import { LayoutComponent } from "../../shared/layout/layout.component";
import { TitleComponent } from "../../shared/title/title.component";
import { InputComponent } from "../../shared/input/input.component";
import { BreadcrumbComponent } from "../../shared/breadcrumb/breadcrumb.component";
import { EnvelopeIconComponent } from "../../shared/icons/envelope/envelope.component";
import { WarningIconComponent } from "../../shared/icons/warning/warning.component";
import { Version, VersionService } from "../../services/version.service";

@Component({
  selector: "app-forgot-password",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RouterLink,
    TranslatePipe,
    LayoutComponent,
    TitleComponent,
    InputComponent,
    BreadcrumbComponent,
    EnvelopeIconComponent,
    WarningIconComponent,
    SpinnerComponent,
  ],
  templateUrl: "./forgot-password.component.html",
  styleUrl: "./forgot-password.component.css",
})
export class ForgotPasswordComponent {
  errorKey: string | null = null;
  success: boolean = false;
  button_clicked: boolean = false;
  email_value: string = "";
  titleText = "b2b.resetPassword.description";

  form: FormGroup = new FormGroup({
    email: new FormControl(""),
  });

  constructor(
    private versionService: VersionService,
    private router: Router,
    private gigyaService: GigyaService,
  ) {
    switch (this.versionService.current) {
      case Version.B2B:
        this.titleText = "b2b.resetPassword.description";
        break;
      case Version.B2C:
        this.titleText = "b2c.resetPassword.description";
        break;
      case Version.NSGO:
        this.titleText = "nsgo.resetPassword.description";
        break;
    }
    this.form.get("email")?.valueChanges.subscribe(() => {
      this.button_clicked = false;
      this.errorKey = null;
      this.success = false;
    });
  }

  public async onSubmit(): Promise<void> {
    this.errorKey = null;
    this.success = false;
    this.button_clicked = true;

    const email = this.form.controls["email"].value;
    this.email_value = email;

    const res = await this.gigyaService.execute(this.gigyaService.client.accounts.resetPassword, {
      loginID: email,
      loginMode: "standard",
    });

    if (res.errorCode !== 0) {
      this.button_clicked = false;
      this.errorKey = this.resolveErrorKey(res.errorCode);
      this.success = false;
      return;
    }
    this.success = true;
  }

  private resolveErrorKey(errorCode: number): string {
    if (errorCode === 403048) return 'resetPassword.errorRateLimit';
    if (errorCode >= 500000 && errorCode < 600000) return 'resetPassword.errorServer';
    return 'resetPassword.error';
  }
}
